export default __webpack_public_path__ + "static/media/ExtraExtra_159x150.32a5c9ba.png";